<div fxLayout="row wrap" fxLayoutAlign="center center" class="layout-wrapper">
  <div fxFlex="80%" fxFlex.lt-md="100%" class="flex-wrapper">
    <ng-content></ng-content>
  </div>
</div>
<div class="github-ribbon">
  <a target="_blank" href="https://github.com/binsky08/amct">Fork me on GitHub</a>
</div>
